<template>
  <el-container type="flex" class="main_container">
    <base-header>接龙详情</base-header>
    <el-main>
      <el-table
        :data="group_buy_info_list"
        v-loading="loading"
        height="100%"
        @sort-change="handleSortChange"
      >
        <el-table-column
          v-for="column in table_column"
          :key="column.index"
          :prop="column.table_prop"
          :label="column.table_label"
          :align="column.table_align"
          :width="column.table_width"
          :sortable="column.sortable"
        ></el-table-column>
        <el-table-column label="已售" sortable prop="sold_count">
        </el-table-column>
        <el-table-column label="库存" prop="good_inventory">
        </el-table-column>
        <el-table-column label="创建时间" :width="140" sortable prop="create_time">
        </el-table-column>
        <el-table-column label="截止时间" prop="end_time">
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </el-footer>
  </el-container>
</template>
<script>
import pageMixin from '../../../mixins/page'
export default {
  name: 'GroupBuy',
  mixins: [pageMixin],
  data () {
    return {
      GroupBuyListURL: this.getDomain() + 'bmsummary/get_group_buy_list', // 接龙详情
      group_buy_info_list: [],
      loading: true,
      table_column: [
        {
          table_prop: 'client_id',
          table_label: 'userID',
          table_align: 'center',
          table_width: '100'
        },
        {
          table_prop: 'good_name',
          table_label: '商品名称',
          table_align: 'center'
        },
        {
          table_prop: 'income',
          table_label: '交易额(元)',
          table_align: 'center'
        },
        {
          table_prop: 'good_price',
          table_label: '单价(元)',
          table_align: 'center'
        }
      ],
      sort_status: undefined,
      sort_t: undefined
    }
  },
  methods: {
    getList () {
      this.loading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize,
        sort_status: this.sort_status, // 0: 降序， 1: 升序
        sort_t: this.sort_t // 0: 按时间排序， 1: 按已售数量排序
      }
      let handle = res => {
        this.totalCount = res.data.content.total_count
        this.group_buy_info_list = res.data.content.group_buy_info_list
        this.group_buy_info_list.forEach(items => {
          items['create_time'] = this.timeTransform(items['create_time'])
          items['income'] = items['income'] / 100
          items['good_price'] = items['good_price'] / 100
          if (!items['end_time']) {
            items['end_time'] = '长期有效'
          } else {
            items['end_time'] = this.timeTransform(items['end_time'])
          }
        })
      }
      let loadings = () => {
        this.loading = false
      }
      this.__axios(this.GroupBuyListURL, params, handle, loadings)
    },
    handleSortChange (val) {
      if (val.prop === 'sold_count' && val.order === 'ascending') {
        this.sort_status = 1
        this.sort_t = 1
      } else if (val.prop === 'sold_count' && val.order === 'descending') {
        this.sort_status = 0
        this.sort_t = 1
      } else if (val.prop === 'create_time' && val.order === 'ascending') {
        this.sort_status = 1
        this.sort_t = 0
      } else {
        this.sort_status = 0
        this.sort_t = 0
      }
      this.getList()
    }
  },
  mounted () {
    this.getList()
  }
}
</script>
